import React, { useState } from 'react';

const LogoutPage: React.FC = () => {
  const [showPopup, setShowPopup] = useState(true);

  const handleLogout = () => {
    // Perform any necessary logout actions here, such as clearing local storage
    localStorage.clear();

    // Redirect to the home page
    window.location.href = '/';
  };

  const handleCancel = () => {
    setShowPopup(false);
    window.history.back();
  }


  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center">
      {/* Your page content here */}

      {/* Logout popup */}
      {showPopup && (
        <div className="fixed inset-0 flex items-center justify-center z-50">
          <div className="absolute inset-0 bg-gray-900 opacity-75"></div>
          <div className="bg-white rounded-lg p-8 z-10 max-w-md mx-auto">
            <h2 className="text-2xl font-bold mb-4">Logout Confirmation</h2>
            <p className="text-gray-600 mb-6">Are you sure you want to logout?</p>
            <div className="flex justify-end">
              <button
                onClick={handleLogout}
                className="bg-red-500 text-white px-4 py-2 rounded-md hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-red-400"
              >
                Yes, Logout
              </button>
              <button
                onClick={() => handleCancel() } 
                className="ml-4 bg-gray-200 text-gray-700 px-4 py-2 rounded-md hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-400"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default LogoutPage;